import * as types from './actionTypes';

const initalState = {
  PackageList: [],
  packageDetails: {},
  updatePackageSuccess: false,
  createPackageSuccess: false,
  statusUpdateSuccess: false,
};

export const packageReducer = (state = initalState, action) => {
  const { type } = action;

  switch (type) {
    case types.SET_PACKAGE_LIST:
      return {
        ...state,
        PackageList: action.payload,
      };
    case types.SET_PACKAGE_DETAILS:
      return {
        ...state,
        packageDetails: action.payload,
      };
    case types.CLEAR_PACKAGE_VIEW:
      return {
        ...state,
        packageDetails: {},
      };
    case types.UPDATE_PACKAGE_SUCCESS:
      return {
        ...state,
        updatePackageSuccess: action.payload,
      };
    case types.CREATE_PACKAGE_SUCCESS:
      return {
        ...state,
        createPackageSuccess: action.payload,
      };
    case types.UPDATE_PACKAGE_STATUS_SUCCESS: {
      const { id, status } = action.payload;
      const packages = state.PackageList?.data?.packages || [];
      const updatedPackages = packages.map((pkg) => (pkg?.id === id ? { ...pkg, status } : pkg));
      return {
        ...state,
        PackageList: {
          ...state.PackageList,
          data: {
            ...state.PackageList?.data,
            packages: updatedPackages,
          },
        },
        statusUpdateSuccess: true,
      };
    }
    case types.SET_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        statusUpdateSuccess: action.payload,
      };

    default:
      return state;
  }
};
